import { useDateLocale, useTimeZone } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { QA_NAME_CALENDAR_GRID } from '../CalendarGrid.constants'
import { getCalendarGridItemsByDay } from '../CalendarGrid.utils'

import { getCalendarGridMonthWeeks } from './CalendarGridMonth.utils'
import { CalendarGridMonthHead } from './CalendarGridMonthHead'
import { CalendarGridMonthWeek } from './CalendarGridMonthWeek'

import * as styles from './CalendarGridMonth.module.css'

function CalendarGridMonth({
  canMoveItems,
  dayLoads,
  days,
  isSkeleton,
  items,
  today,
  weekdays,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const itemsByDay = getCalendarGridItemsByDay({ items, locale, timezone })

  return (
    <div className={styles.CalendarGridMonth}>
      <CalendarGridMonthHead weekdays={weekdays} />
      <div
        {...getQaSelector({ value: QA_NAME_CALENDAR_GRID })}
        className={styles.grid}
      >
        {getCalendarGridMonthWeeks(days).map(weekDays => (
          <CalendarGridMonthWeek
            canMoveItems={canMoveItems}
            dayLoads={dayLoads}
            days={weekDays}
            isSkeleton={isSkeleton}
            itemsByDay={itemsByDay}
            key={weekDays[0].date}
            today={today}
            onClickItem={onClickItem}
            onClickSecondaryLabel={onClickSecondaryLabel}
          />
        ))}
      </div>
    </div>
  )
}

export default CalendarGridMonth
